import React, { useEffect, useState } from 'react';
import cls from '@utils/css-select';
import i18n from '@fe/i18n/dist/i18n';
import dayjs from 'dayjs';

import styles from './styles.scss';
import Section from 'components/section';
import trace from '../../trace';
const cx = cls(styles);

const str = i18n.getMessages('landing');
interface IFooterProps {
	tint: boolean;
}
interface ICountdownProps {
	show: boolean;
	onClickBtn(): void;
}
const Countdown = (props: ICountdownProps) => {
	const [time, setTime] = useState({ h: 14, m: 59, s: 34 });
	const to2Digit: (num: number) => string = (num) => {
		return ('0' + num).slice(-2);
	}
	useEffect(() => {
		const start = dayjs().hour(14).minute(59).second(34);
		let now = start.clone();
		const timer = setInterval(() => {
			if (now.format('HH:mm:ss') === '00:00:00') {
				now = start.clone();
			} else {
				now = now.add(-1, 's');
			}
			setTime({
				h: now.hour(),
				m: now.minute(),
				s: now.second(),
			});
		}, 1000);
		return () => clearInterval(timer);
	}, []);
	return (
		<div
			className={cx('fixed-footer', 'count-down', {
				hidden: !props.show,
			})}>
			<Section className={cx('inner')}>
				<img
					loading="lazy"
					className={cx('img')}
					src="https://web-data.zmlearn.com/image/nDUopweY1gfKky5GLJJ6CM/foot.png"
					alt="air-class"
				/>
				<div className={cx('content')}>
					<p>Remaining time to get this free class</p>
					<div className={cx('time-down')}>
						<div>{to2Digit(time.h)}</div>
						<span>:</span>
						<div>{to2Digit(time.m)}</div>
						<span>:</span>
						<div>{to2Digit(time.s)}</div>
					</div>
				</div>
				<div className={cx('btn')} onClick={props.onClickBtn}>
					10 Openings Left!
				</div>
			</Section>
		</div>
	);
}
/**
 * 底部footer
 */
export default function Footer(props: IFooterProps) {
	const [show, setShow] = useState(false);
	useEffect(() => {
		// 滚动
		const formEle = document.querySelector('#form-ele') as HTMLDivElement;

		const options = {
			threshold: [0, 0.25, 0.5, 0.75],
		};

		const observer = new IntersectionObserver((entries) => {
			setShow(entries[0].intersectionRatio <= 0);
		}, options);
		observer.observe(formEle);
		return () => {
			observer.disconnect();
		};
	}, []);

	function handleBtnClick() {
		const ele = document.querySelector('#form-ele');
		trace('footerBtnClick');
		// eslint-disable-next-line no-unused-expressions
		ele?.scrollIntoView(true);
		setShow(false);
	}

	if (props.tint) {
		return <Countdown show={show} onClickBtn={handleBtnClick} />
	}
	return (
		<div
			className={cx('fixed-footer', {
				hidden: !show,
			})}>
			<Section className={cx('inner')}>
				<img
					loading="lazy"
					className={cx('img')}
					src="https://web-data.zmlearn.com/image/nDUopweY1gfKky5GLJJ6CM/foot.png"
					alt="air-class"
				/>
				<p>
					Get a {str('ft.price')} online session <strong>for FREE</strong>
				</p>
				<div className={cx('btn')} onClick={handleBtnClick}>
					Request now!
				</div>
			</Section>
		</div>
	);
}
